
import useRemoveProjectMutation from "@/api/mutation/useProjectRemoveMutation";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import { Button } from "@/components/ui/button";
import { useUser } from "@/hooks/useUser";
import {
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import TrashCan from "@/assets/svg/TrashCan.svg";
import { Project } from "@/api/query/useProjectQuery";
import Dialog from "@/components/common/Dialog";
import { CreateProjectNoPopUpForm, SubmitRef } from "@/components/project/CreateProjectNoPopupForm";
import Loader from "@/components/common/Loader";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";


 const ProjectDetails = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const projectDetailQuery = useProjectDetail(id,true);
  const { user } = useUser();

  const submit = useRef<SubmitRef | null>(null);
  const verification = () => {
    if (user?.userOrganisation[0]?.role === UserRoleEnumValue.ADMINISTRATOR) {
      return true;
    } else {
      const projectManager =
        projectDetailQuery.data?.data.data.assignedUsers.find((item) => {
          if (
            (item.projectRole === UserRoleEnumValue.PROJECT_MANAGER ||
              item.projectRole === UserRoleEnumValue.ADMINISTRATOR) &&
            user?.userId === item.user.userId
          )
            return item;
        });
      if (projectManager) {
        return true;
      }
    }
    return false;
  };
  const isProjectAdmin = projectDetailQuery.data?.data.data.assignedUsers.some((item) => item.projectRole === UserRoleEnumValue.ADMINISTRATOR &&user?.userId === item.user.userId);
  const currentUserIsAdmin = verification();

  const [readOnly, setReadOnly] = useState<boolean>(true);
  const [remove, setRemove] = useState<boolean>(false);
  const removeProjectMutation = useRemoveProjectMutation();

  const removeProject = () => {
    removeProjectMutation.mutate(id ?? "", {
      onSuccess(data) {
        toast.success(data.data.message);
        navigate(`/projects`);
      },
      onError(error) {
        toast.error(errorKeyFormate(error.response?.data.message+'') );
      },
    });
  };
  const {t}=useTranslation();
  const handleSubmit = () => {
    submit.current?.callSubmit();
  };

  return (
    <div className="w-full relative h-full overflow-auto">
      {projectDetailQuery.isLoading ? (
        <Loader className="absolute top-0 left-0 w-full h-full" />
      ) : (
        <>
          {/* <SideBar
            toggleSidebar={toggleSidebar}
            isSidebarExpanded={isSidebarExpanded}
          /> */}
          <div
            className={`mt-5 overflow-auto ml-4`}
          >
            <div className="sm:px-10 px-3">
              {readOnly &&  <div className="bg-primary-500 sm:px-4 text-center my-4 text-white text-sm font-normal rounded-md py-1.5 px-4 w-fit">
                {t(projectDetailQuery.data?.data.data.status??"NOT_STARTED")}
              </div>}
              <div className="sm:text-3xl text-xl lg:text-2xl font-semibold flex lg:flex-row flex-col gap-4 lg:justify-between items-start lg:items-end my-2.5">
                {t("project_details")}
                <div className="flex gap-3 items-center ml-auto">
                  {currentUserIsAdmin && (
                    <div className="ml-auto flex gap-3">
                      {readOnly ? (
                        <Button
                          size={"sm"}
                          className=""
                          variant={"primary"}
                          onClick={() => setReadOnly(!readOnly)}
                        >
                          <div className="flex gap-2 items-center">
                            {" "}
                            <img src={NewEditIcon} className="brightness-0 invert" /> {t("edit")}
                          </div>{" "}
                        </Button>
                      ) : (
                        <Button
                          size={"sm"}
                          className=""
                          variant={"primary"}
                          onClick={handleSubmit}
                        >
                          <div className="flex gap-2 items-center"> {t("save")}</div>{" "}
                        </Button>
                      )}
                      {readOnly  ? (
                        isProjectAdmin && <Button
                          size={"sm"}
                          variant={"destructive"}
                          onClick={() => setRemove(true)}

                        >
                          <div className="flex gap-2 items-center">
                            {" "}
                            <img
                              src={TrashCan}
                              className="invert sepia-[30%] saturate-[1%] hue-rotate-[60deg] brightness-[10%] contrast-[150%]"
                            />{" "}
                            {t("delete_project")}
                          </div>{" "}
                        </Button>
                      ) : (
                        <Button
                          size={"sm"}
                          variant={"secondary"}
                          onClick={() => {projectDetailQuery.refetch(); setReadOnly(!readOnly);}}
                        >
                          <div className="flex gap-2 items-center"> {t("cancel")}</div>{" "}
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>
             
              <hr />
              <div className="py-3">
                <CreateProjectNoPopUpForm
                  ref={submit}
                  key={readOnly+""}
                  viewOnly={
                    (currentUserIsAdmin ? false : true) === false &&
                    readOnly == false
                      ? false
                      : true
                  }
                  refetch={projectDetailQuery.refetch}
                  editData={
                    projectDetailQuery.data?.data.data as unknown as Project
                  }
                  cancel={() => setReadOnly(!readOnly)}
                />
              </div>
            </div>
          </div>
        </>
      )}
      <Dialog isOpen={remove} onClose={() => {}} modalClass="rounded-lg">
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" /> {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeProjectMutation.isPending}
              disabled={removeProjectMutation.isPending}
              onClick={() => setRemove(false)}
            >
              {t("cancel")}
            </Button>
            <Button variant={"primary"} className="text-white" onClick={removeProject}>
              { t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
export default ProjectDetails;